export default "__VITE_ASSET__C_vp62x8__"